module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Productdetails"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.product.amount_sold_past_year > 25) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa fa-info-circle mr-5"
  }), _vm._v(" Hardloper")])]) : _vm._e(), _vm._v(" "), (_vm.product === null) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Gegevens")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Naam")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.name))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("SKU")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.sku))])]), _vm._v(" "), (_vm.product.parent_sku) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("SKU Hoofdproduct")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.parent_sku))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("GTIN")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.gtin))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Prijs")]), _vm._v(" "), _c('td', [_c('price-editable', {
    key: _vm.product.id,
    attrs: {
      "price": _vm.product.price,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Sale prijs")]), _vm._v(" "), _c('td', [_c('sale-price-editable', {
    key: _vm.product.id,
    attrs: {
      "price": _vm.product.price,
      "sale_price": _vm.product.sale_price,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Inkoopprijs")]), _vm._v(" "), _c('td', [_c('purchase-price-editable', {
    key: _vm.product.id,
    attrs: {
      "purchase-price": _vm.product.purchase_price,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Locatie")]), _vm._v(" "), _c('td', [_c('location-editable', {
    key: _vm.product.id,
    attrs: {
      "field": "location",
      "value": _vm.product.location,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Locatie overvoorraad")]), _vm._v(" "), _c('td', [_c('field-editable', {
    key: _vm.product.id,
    attrs: {
      "field": "overstock_location",
      "value": _vm.product.overstock_location,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Ligt in de winkel")]), _vm._v(" "), _c('td', [_c('in-store-editable', {
    key: _vm.product.id,
    attrs: {
      "in-store": !!_vm.product.in_store,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Cadeaukoppeling")]), _vm._v(" "), _c('td', [_c('externally-available-editable', {
    key: _vm.product.id,
    attrs: {
      "externally-available": !!_vm.product.externally_available,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Voorraad")]), _vm._v(" "), _c('td', [_c('stock-editable', {
    key: _vm.product.id,
    attrs: {
      "quantity": _vm.product.stock_quantity,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Maat")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.size))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Gemaakt op")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(_vm.product.created_at, 'calendar')))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Beschrijving")]), _vm._v(" "), _c('td', {
    staticClass: "reset-font-size",
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Afbeelding(en)")]), _vm._v(" "), _c('td', _vm._l((_vm.product.image_urls), function(imageUrl) {
    return _c('img', {
      key: imageUrl,
      staticClass: "img-thumbnail mr-10",
      attrs: {
        "width": "100",
        "src": imageUrl,
        "alt": ""
      }
    })
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Voorraadmutaties")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Mutatie")]), _vm._v(" "), _c('th', [_vm._v("Van")]), _vm._v(" "), _c('th', [_vm._v("Naar")]), _vm._v(" "), _c('th', [_vm._v("Oorzaak")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.product.stock_mutations), function(mutation) {
    return _c('tr', {
      key: mutation.id
    }, [_c('td', [_vm._v(_vm._s(_vm._f("moment")(mutation.created_at, 'DD-MM-YYYY HH:mm')))]), _vm._v(" "), _c('td', [((mutation.new_quantity - mutation.old_quantity) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(mutation.new_quantity - mutation.old_quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mutation.old_quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mutation.new_quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("origin")(mutation.origin)))])])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger",
    on: {
      "click": _vm.removeProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-times mr-5"
  }), _vm._v("\n      Verwijder product\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24cec75e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/ProductDetailModal.vue
// module id = 698
// module chunks = 1